export default "__VITE_ASSET__t_yo0J2c__"